import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";


export const categoryApi = createApi({
    reducerPath: "categoryApi",
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        getCategories: builder.query({
            query: ({ page, limit, keyword, status }) => {
                let url = "/categories"
                if (page) url += `?page=${page}`;
                if (limit) url += `&limit=${limit}`;
                if (keyword) url += `&keyword=${keyword}`;
                if (status) url += `&status=${status}`;
                return {
                    url,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
        }),
        getCategoryById: builder.query({
            query: (id) => ({
                url: `/categories/${id}`,
                method: "GET",
            }),
            transformResponse: (response) => response.data,
        }),
        createCategory: builder.mutation({
            query: (category) => ({
                url: "/categories",
                method: "POST",
                body: category,
            }),
            transformResponse: (response) => response.data,
        }),
        updateCategory: builder.mutation({
            query: ({ id, data }) => ({
                url: `/categories/${id}`,
                method: "PUT",
                body: data,
            }),
            transformResponse: (response) => response.data,
        }),
        deleteCategory: builder.mutation({
            query: (id) => ({
                url: `/categories/${id}`,
                method: "DELETE",
            }),
            transformResponse: (response) => response.data,
        }),

    }),
});


export const {
    useGetCategoriesQuery,
    useGetCategoryByIdQuery,
    useCreateCategoryMutation,
    useUpdateCategoryMutation,
    useDeleteCategoryMutation,
} = categoryApi;